import React from 'react'
import { connect } from 'react-redux'
import { REDUCER } from 'ducks/email_verification'
import l8n, { e } from 'l8n'
import Form from 'antd/lib/form'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'
import {sprintf} from "sprintf-js";
import linkit from 'scripts/linkit';
import message from "antd/lib/message";
import './style.scss'

const mapStateToProps = (state, props) => ({
  formSubmitted: state.app.submitForms[REDUCER],
});

@connect(mapStateToProps)
@Form.create()
class EmailVerificationForm extends React.Component {
  state = {
    codeSent: false,
    sendProcessing: false,
  }

  onSubmit = (formSubmitted) => event => {
    event.preventDefault()
    const { form } = this.props
    if (!formSubmitted) {
      form.validateFields((error, values) => {
        if (!error) {
          this.props.onSubmit(values)
        }
      })
    }
  }

  getTextSent = () => {
    const text = l8n['emailVerify.popup.textSent']
      .replace('{email}', `{link}${this.props.email}{/link}`);

    return linkit(text, [{className: 'text-primary', onClick: null}]);
  }

  resendCodeClick = async () => {
    this.setState({
      sendProcessing: true,
    });
    try {
      await this.props.onSendCode()
      this.setState({
        codeSent: true,
        sendProcessing: false,
      })
      message.success(l8n['emailVerify.popup.codeSent'])
    } catch (e) {
      this.setState({
        sendProcessing: false,
      })
    }
  }

  render() {
    const { form, formSubmitted, onProfile } = this.props;
    const { sendProcessing } = this.state
    return (
      <div className='email-verification'>
        <h2>
          {l8n['emailVerify.popup.header']}
        </h2>
        <p>{this.getTextSent()}</p>
        <Form
          className="email-verification__form"
          layout='inline'
          hideRequiredMark
          onSubmit={this.onSubmit(formSubmitted)}
        >
          <Form.Item>
            {form.getFieldDecorator('code', {
              rules: [
                { required: true, message: e(l8n['p_required']) },
                { len: 6, message: e(sprintf(l8n['req_len'], l8n['emailVerify.popup.label'], 6)) },
                { pattern: /^\d+$/, message: e(l8n['req_onlyDigits']) },
              ],
            })(
              <Input
                placeholder={l8n['emailVerify.popup.placeholder']}
                data-qa-id="email-verify-code-input"
                type="text"
              />
            )}
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={formSubmitted}
              data-qa-id="email-verify-submit-button"
            >
              {l8n['emailVerify.popup.button.check']}
            </Button>
          </Form.Item>
        </Form>
        <p>
          {linkit(l8n['emailVerify.popup.textCheck'], [{
            onClick: onProfile,
            className: 'text-primary utils__link--underlined',
            dataQaId: 'email-verify-profile-link'
          }])}
        </p>
        {! this.state.codeSent && (
          <Button
            type='success'
            onClick={this.resendCodeClick}
            loading={sendProcessing}
          >
            {l8n['emailVerify.popup.button.send']}
          </Button>
        )}
      </div>
    )
  }
}

export default EmailVerificationForm



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/EmailVerificationForm/index.js